<template>
  <vs-popup id="popup" :title="title" :active.sync="showPopup">
    <div class="overflow-x-auto">
      <table>
        <colgroup>
          <col width="60" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>No.</th>
            <th>이미지</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in boardList"  :key="`table_row_${index}`" @click="selectRowData(item)" :class="selectData && selectData.id == item.id && 'select-row'">
            <td>{{ index + 1 }}</td>
            <td>
              <div class="flex flex-row items-center gap-4">
                <div v-for="photo in item.body.photoList" >
                  <img v-if="photo.path" :src="photo.path" alt="이미지" class="w-20 h-20" width="300" height="200"/>
                  <div v-else style="width: 300px; height: 200px; border: 1px solid #cdcdcd"></div>
                  <p>{{ photo.input? photo.input : '' }}</p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="vs-con-table mb-6">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="page.lastPage ? page.lastPage : 1" :value="page.current" @change="handleChangePage" />
<!--        <vs-button v-if="checkList.length > 0" class="" color="secondary" type="border" style="width: 150px; position: absolute" @click="onClickUse">불러오기</vs-button>-->
      </div>
    </div>
    <div class="flex justify-end gap-4">
      <vs-button color="secondary" type="border" style="width: 112px" @click="cancelBtn">닫기</vs-button>
<!--      <vs-button color="secondary" style="width: 112px" @click="onClickUse">선택완료</vs-button>-->
    </div>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination.vue";
import singlePageList from "@/views/boards/single-page/listIndex";

export default {
  name: "PopupImageList",
  components: {KPagination},
  props: {
    title: {
      type: String,
      default: "이전 문서 불러오기",
    },
    setBoardId: Number,
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      showPopup: this.value,

      nav: {
        value: {},
      },
      total: 0,
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 5,
      },
      // 검색
      search: {
        value: {},
        loading: false,
      },
      boardList: [],

      selectData: null,

    };
  },
  watch: {
    value: {
      handler(value) {
        this.showPopup = value;
        if (value) {
          this.page.current = 1;
          this.loadBoardList();
        }
      },
    },
    showPopup(value) {
      const body = document.querySelector("body");
      if (value) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "auto";
      }
      this.$emit("input", value);
    },
  },
  created() {
    this.boardList = [];
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    getConditions() {
      return singlePageList[`${this.setBoardId}_list`].components;
    },
  },
  methods:{
    async loadBoardList () {
      // 팝업이 닫혀있는 동안에는 조회하지 않는다.
      // (vs-popup 은 닫혀있어도 슬롯을 렌더링하므로, k-pagination 이 mount 되며 change 이벤트를 발생시킨다)
      if (!this.showPopup) return;

      const conditions = this.getConditions;
      const options = {
        projectId: this.projectId,
        boardId: this.setBoardId,
        page: this.page.current,
        perPage: this.page.perPage,
        conditions,
      }

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const { current_page, last_page, data } = response;

      this.boardList = response.data.map((data) => {return {id: data.id, ...JSON.parse(data.post_content)}});
      this.total = response.total;
      this.page.lastPage = response.last_page;
      this.page.current = (this.page > this.lastPage) ? this.lastPage : this.page

      this.page.current = current_page;
      this.page.lastPage = last_page;
    },
    selectRowData(data) {
      return

      if (this.selectData && this.selectData.id === data.id) this.selectData = null;
      else this.selectData = data;
    },
    handleChangePage(page) {
      // 이미 조회된 페이지인 경우 중복 호출을 막는다
      if (page === this.page.current) {
        return;
      }
      this.page.current = page;
      this.loadBoardList();
    },
    cancelBtn() {
      this.showPopup = false;
    },
    onClickUse() {
      this.showPopup = false
      this.$emit("selectRowData", this.selectData);
    },
  }
}
</script>

<style lang="scss" scoped>
#popup::v-deep {
  .vs-popup {
    width: 90% !important;
    @media print, screen and (min-width: theme("screens.xl")) {
      width: 70% !important;
    }
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 2px solid #f8f8f8;

  th,
  td {
    text-align: center;
    padding: 10px;
    transition: all 0.3s ease;
  }

  tr {
    cursor: pointer;

    &.fake {
      cursor: default;
    }

    &.select-row td {
      background-color: #6670cb !important;
      color: white;
    }

    &:nth-child(2n-1) {
      background-color: #f9f9f9;
    }
    &:hover {
      z-index: 200;

      td {
        -webkit-transform: translateY(-4px);
        transform: translateY(-4px);
      }
    }
  }
}
</style>
